<template>
  <div class="filter">
    <filter-bar name="出发日期" :count="5" :options="monthsData" :is-all="searchData.months.length == 0" @on-clear="handleClearSearch('months')">
      <template #item="{ option }">
        <v-checkbox v-model="searchData.months" :val="option.year_month" @change="handleFitlerChange">
          {{ option.text }}
        </v-checkbox>
      </template>
    </filter-bar>
    <filter-bar name="行程天数" :count="5" :options="filterData.days" :is-all="searchData.days.length == 0" @on-clear="handleClearSearch('days')">
      <template #item="{ option }">
        <v-checkbox v-model="searchData.days" :val="`${option.gte}-${option.lte}`" @change="handleFitlerChange">{{ option.value }}</v-checkbox>
      </template>
    </filter-bar>
    <filter-bar name="价格区间" :count="5" :options="filterData.price" :is-all="searchData.price_section.length == 0" @on-clear="handleClearSearch('price_section')">
      <template #item="{ option }">
        <v-checkbox v-model="searchData.price_section" :val="`${option.gt}-${option.lte}`" @change="handleFitlerChange">{{ option.value }}</v-checkbox>
      </template>
    </filter-bar>
    <filter-bar name="假期选择" :count="5" :options="filterData.holiday" :is-all="searchData.date.length == 0" @on-clear="handleClearSearch('date')">
      <template #item="{ option }">
        <v-checkbox v-model="searchData.date" :val="option.value" @change="handleFitlerChange">
          {{ option.name }}
        </v-checkbox>
      </template>
    </filter-bar>
  </div>
</template>

<script>
import CheckboxGroup from "../product/ListFilterCheckboxGroup";
import FilterBar from "../product/ListFilterBar";
import { pick, merge } from "@/utils/helpers.js";

import { getProductCustomerFilter } from "~/services/product";

import { REQUEST_CODES } from "@/constants/const-http.js";

export default {
  name: "CustomerListFilter",
  components: { CheckboxGroup, FilterBar },
  async fetch() {
    try {
      let { code, data, msg } = await getProductCustomerFilter();
      if (code !== REQUEST_CODES.ERROR_OK) {
        console.error(msg);
        return;
      }
      console.log(data);
      this.filterData = data;
    } catch (error) {
      console.error(error);
    }
  },
  data() {
    return {
      filterData: {
        date: [],
        holiday: [],
        price: [],
        brand: [],
        route: [],
        days: [],
        departure_city: [],
      },
      searchData: {
        months: [],
        days: [],
        date: [],
        price_section: [],
      },
    };
  },
  computed: {
    // ...mapState(["filterData"]),
    monthsData() {
      return this.filterData.date.reduce((months, year) => {
        return year.month.reduce((months, month, monthIndex) => {
          let text =
            monthIndex === 0
              ? `${month.year}年${month.month}月`
              : `${month.month}月`;
          months.push({ ...month, text });
          return months;
        }, months);
      }, []);
    },
  },
  mounted() {
    // let { query } = this.$route;
    // merge(this.searchData, pick(query, Object.keys(this.searchData)));
  },
  methods: {
    handleClearSearch(key) {
      this.searchData[key] = [];

      this.$nextTick(this.handleFitlerChange);
    },
    handleFitlerChange() {
      this.$emit("on-filter-change", this.searchData);
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/assets/scss/base/_color";
.filter {
  background: #fff;
  padding: 13px 17px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
  &-item {
    width: 16.5555%;
    margin-top: 7px;
    margin-bottom: 7px;

    &.all-wraper {
      width: 60px;
    }
  }
}

.label {
  max-width: 5.5em;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
